import { floatUnmask, removeSpace } from 'utils/masks';

const ConfirmMicroDepositSchema = (decimalPlaces = 8) => ({
  amount: [{
    rule: 'required',
    isValid: (input) => {
      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      }

      const decimals = (floatUnmask(input).split('.')[1] || '').length;

      if (decimals < decimalPlaces) {
        return `Enter all ${decimalPlaces} decimal places exactly as shown in your wallet`;
      }

      return true;
    },
  }],
});

export default ConfirmMicroDepositSchema;
